import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { packItems, volumes, volumesIntro } from '../data/gymklar';
export function WhatsInside() {
  const [active, setActive] = useState<number>(0);
  const volume = volumes[active];
  return <section id="inside" className="w-full bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-265" data-mp="pujaxj4imb7s">
      <div className="mx-auto max-w-6xl" data-id="element-266" data-mp="b5wn0t0tob4y">
        <h2 className="mx-auto max-w-3xl text-center font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-267" data-mp="b4vcqqrmrsoa">
          Hva inneholder <em className="text-red-700" data-id="element-268" data-mp="269vr01t4lpm">GYMKLAR™</em>?
        </h2>

        <div className="mt-16 grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-269" data-mp="23nf8awxuvv9">
          <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-270" data-mp="75cphocc75ia">
            {volumesIntro.title}
          </h3>
          <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-271" data-mp="3tbrss2z8tb2i">{volumesIntro.text}</p>
        </div>

        <div role="tablist" aria-label="Volumer" className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-3 lg:grid-cols-6" data-id="element-272" data-mp="3ct4n6n6nj1xj">
          {volumes.map((item, index) => {
          const isActive = index === active;
          return <button key={item.number} type="button" role="tab" id={`volume-tab-${index}`} aria-selected={isActive} aria-controls="volume-panel" onClick={() => setActive(index)} className={`flex h-56 flex-col rounded-lg border-r-8 border-black/10 p-4 text-left shadow-xl shadow-slate-900/20 transition-[transform,opacity] duration-200 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-red-700/40 sm:h-64 lg:h-72 ${item.spine} ${isActive ? '-translate-y-2' : 'opacity-75 hover:-translate-y-1 hover:opacity-100'}`} data-id="element-273" data-mp="3ltkktg0preuh" data-mpi={index}>
                <span className="text-xs font-semibold opacity-80" data-id="element-274" data-mp="2y2x17xhfr0s3">{item.number}</span>
                <span className="mt-1 font-serif text-3xl leading-none" data-id="element-275" data-mp="2adm9f5i2cgq3">{item.level}</span>
                <span className={`mt-auto border-t pt-3 text-sm font-medium leading-snug ${item.rule}`} data-id="element-276" data-mp="26dc3tty6nsbr">
                  {item.title}
                </span>
              </button>;
        })}
        </div>

        <div id="volume-panel" role="tabpanel" aria-labelledby={`volume-tab-${active}`} className="mt-8 border-t border-slate-900/15 pt-10" data-id="element-277" data-mp="eaptbdbfgxp5">
          <AnimatePresence mode="wait" initial={false} data-id="element-278" data-mp="o1ubelwegyo7">
            <motion.div key={volume.number} initial={{
            opacity: 0,
            y: 6
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0,
            y: -6
          }} transition={{
            duration: 0.18,
            ease: [0.23, 1, 0.32, 1]
          }} className="grid gap-10 lg:grid-cols-12" data-id="element-279" data-mp="o1kfyisl5zb4">
              <div className="lg:col-span-5" data-id="element-280" data-mp="5cno0lknviw2">
                <p className="text-sm font-semibold text-red-700" data-id="element-281" data-mp="59jf5aw93yz2">
                  {volume.number} · {volume.level}
                </p>
                <h4 className="mt-2 font-serif text-3xl leading-tight text-slate-900 sm:text-4xl" data-id="element-282" data-mp="1gq9kyswrios5">{volume.title}</h4>
                <p className="mt-4 text-lg leading-relaxed text-slate-900/80" data-id="element-283" data-mp="317sahg880r67">{volume.tagline}</p>
                <p className="mt-3 leading-relaxed text-slate-900/70" data-id="element-284" data-mp="2was577j73sg5">{volume.intro}</p>
              </div>
              <div className="lg:col-span-7" data-id="element-285" data-mp="2rhpj1kgqzl9z">
                <p className="text-sm font-semibold text-slate-900/60" data-id="element-286" data-mp="2mjxglwih8grj">Inneholder</p>
                <ul className="mt-4 grid gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-287" data-mp="2mhte9j087ptd">
                  {volume.items.map(entry => <li key={entry} className="flex gap-3 text-[15px] leading-snug text-slate-900/80" data-id="element-288" data-mp="2hihue14kc47k">
                      <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-700" strokeWidth={2.5} aria-hidden="true" data-id="element-289" data-mp="2dllr5xtcjp0o" />
                      {entry}
                    </li>)}
                </ul>
                <p className="mt-6 font-serif text-xl italic leading-snug text-slate-900/80" data-id="element-290" data-mp="23nee3q26hr3y">{volume.outro}</p>
                {volume.note && <p className="mt-3 text-xs leading-relaxed text-slate-900/60" data-id="element-291" data-mp="1tydq1gagxvs">{volume.note}</p>}
              </div>
            </motion.div>
          </AnimatePresence>
        </div>

        <div className="mt-24 border-t border-slate-900/15 pt-12" data-id="element-292" data-mp="2zn9sio565xl1">
          <div className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-293" data-mp="2zmqc5bv63h94">
            <h3 className="font-serif text-3xl leading-tight text-slate-900 sm:text-4xl lg:col-span-6" data-id="element-294" data-mp="2loa6lo91jwsk">
              Hva gjør GYMKLAR™ annerledes?
            </h3>
            <p className="text-lg leading-relaxed text-slate-900/75 lg:col-span-6" data-id="element-295" data-mp="2bxpac7gub4ct">
              Et helt skoleår med kroppsøving – organisert og klart til bruk.
            </p>
          </div>
          <ul className="mt-12 grid gap-x-10 gap-y-12 sm:grid-cols-2 lg:grid-cols-3" data-id="element-296" data-mp="2gq8iuq0o79ar">
            {packItems.map(item => {
            const Icon = item.icon;
            return <li key={item.title} data-id="element-297" data-mp="27wlq78rrem5s">
                  <Icon className="h-6 w-6 text-red-700" strokeWidth={1.75} aria-hidden="true" data-id="element-298" data-mp="1sytd0n9oq9ur" />
                  <h4 className="mt-4 font-serif text-2xl leading-tight text-slate-900" data-id="element-299" data-mp="1xxwjmc5bco4u">{item.title}</h4>
                  <p className="mt-2 text-sm leading-relaxed text-slate-900/70" data-id="element-300" data-mp="1ebuq95lrw3md">{item.text}</p>
                </li>;
          })}
          </ul>
        </div>
      </div>
    </section>;
}